export class HashRequest {
  public data: string;

  constructor(data: string) {
    this.data = data;
  }
}

export class HashResponse {
  public signature = '';
}
